import { t } from "i18next";

export const paymentMethodOptions = [
  { id: 1, name: t("accounting.views.cash")},
  { id: 2, name: t("accounting.views.dataphone")},
  { id: 3, name: t("accounting.views.transfer")},
  { id: 4, name: t("accounting.views.simple")},
  { id: 5, name: t("accounting.views.other")},
];

export const transactionTypeOptions = [
  { id: "sponsorship", name: "Patrocinio" },
  { id: "sale", name: "Venta" },
  { id: "rent", name: "Alquiler" },
  { id: "camp", name: "Campamento" },
  { id: "intensive_courses", name: "Cursos intensivos" },
  { id: "fee", name: "Cuotas" },
  { id: "others", name: "Otras" },
];

export const subcategoriesOptions = [
  { id: "salaries_for_coaches", name: "Salarios y sueldos para entrenadores" },
  {
    id: "salaries_for_lessons",
    name: "Salarios y sueldos para actividades dirigidas",
  },
  {
    id: "salaries_for_reception_staff",
    name: "Salarios y sueldos para personal de recepción",
  },
  {
    id: "salaries_and_wages_for_cleaning",
    name: "Salarios y sueldos para limpieza",
  },
  {
    id: "salaries_for_maintenance",
    name: "Salarios y sueldos para mantenimiento.",
  },
  {
    id: "salaries_for_other_staff",
    name: "Salarios y sueldos de otro personal.",
  },
  {
    id: "other_labor_charges",
    name: "Seguros sociales y otras cargas laborales.",
  },
  {
    id: "purchase_or_lease_of_equipment",
    name: "Compra o arrendamiento de equipos de gimnasio (máquinas de cardio, pesas, bancos, etc.).",
  },
  {
    id: "maintenance_or_repair_of_equipment",
    name: "Mantenimiento y reparación de equipos.",
  },
  {
    id: "acquisition_and_replacement_of_accessories",
    name: "Adquisición y reposición de accesorios y materiales (colchonetas, bandas elásticas, etc.).",
  },
  {
    id: "rental_or_mortgage_of_physical_space",
    name: "Alquiler o hipoteca del espacio físico.",
  },
  { id: "electricity", name: "Electricidad" },
  { id: "water", name: "Agua" },
  { id: "gas", name: "Gas" },
  { id: "internet", name: "Internet" },
  { id: "telephony", name: "Telefonía" },
  {
    id: "cleaning_and_maintenance_of_facilities",
    name: "Limpieza y mantenimiento de las instalaciones.",
  },
  {
    id: "property_and_civil_liability_insurance",
    name: "Seguros de propiedad y responsabilidad civil.",
  },
  {
    id: "management_software",
    name: "Software de gestión (CRM, contabilidad, etc.).",
  },
  { id: "office_supplies", name: "Material de oficina y suministros." },
  {
    id: "professional_services",
    name: "Servicios profesionales (contabilidad, asesoría legal).",
  },
  {
    id: "online_and_offline_advertising_campaigns",
    name: "Campañas publicitarias online y offline.",
  },
  {
    id: "promotion_on_social_networks_and_website_management",
    name: "Promoción en redes sociales y manejo de sitio web.",
  },
  {
    id: "special_events_and_promotions",
    name: "Eventos y promociones especiales.",
  },
  {
    id: "purchase_of_products",
    name: "Compra de productos para la reventa (bebidas, suplementos, ropa deportiva).",
  },
  {
    id: "transportation_and_logistics_expenses",
    name: "Transporte y logística.",
  },
  { id: "special_event_expenses", name: "Eventos especiales" },
  { id: "taxes", name: "Impuestos locales, estatales y federales." },
  { id: "licenses_and_permits", name: "Licencias y permisos necesarios." },
  {
    id: "safety_equipment_and_protocols",
    name: "Equipos y protocolos de seguridad.",
  },
  {
    id: "first_aid_materials",
    name: "Material de primeros auxilios y desfibriladores.",
  },
  {
    id: "compliance_with_hygiene_and_health_regulations",
    name: "Cumplimiento de normativas de higiene y salud.",
  },
  {
    id: "software_and_hardware",
    name: "Actualización de software y hardware.",
  },
  {
    id: "investment_in_new_technologies",
    name: "Inversión en nuevas tecnologías (apps de fitness, sistemas de seguimiento de clientes).",
  },
  {
    id: "others",
    name: "Imprevistos o no categorizables en las otras secciones.",
  },
];
